import { useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';

import Scrollbar from 'react-custom-scrollbars';
import useUIContext from '../../ui/use-ui-context';
import UIContext from '../../ui/ui-context';
import { selectIsDesktop } from '../brand/ducks/selectors.js';
/**
 * If Desktop, adding a custom Scrollbar to layout for consistent scroll
 * layout in windows, linux and mac machines
 * This is only added to Desktop and Mobile view is retained as it is
 * Checking isDesktop property to from Brand to check the desktop or mobile
 * @param {Component} Layout
 * @param {style} Class to give to the custom scroll-bar
 */

const customDesktopScroll = (WrappedComponent, style = 'desktop-scrollbar') => {
	const CheckScroll = props => {
		const isDesktop = useSelector(selectIsDesktop);
		const scrollbar = useRef();
		const uiContext = useUIContext();
		const newUiContext = useMemo(() => ({ ...uiContext, scrollbar }), [uiContext, scrollbar]);

		if (!isDesktop) {
			return <WrappedComponent {...props} />;
		}

		if (newUiContext.showModal) {
			return (
				<Scrollbar
					className={style}
					autoHeightMin="100%"
					autoHeightMax="100%"
					autoHide
					autoHeight
					ref={scrollbar}
				>
					<UIContext.Provider value={newUiContext}>
						<WrappedComponent {...props} scrollbar={scrollbar} />
					</UIContext.Provider>
				</Scrollbar>
			);
		}

		// TODO Remove scrollbar prop from descendants and use uicontext
		return (
			<Scrollbar className={style} autoHide ref={scrollbar}>
				<UIContext.Provider value={newUiContext}>
					<WrappedComponent {...props} scrollbar={scrollbar} />
				</UIContext.Provider>
			</Scrollbar>
		);
	};

	return CheckScroll;
};

export default customDesktopScroll;
